import { TOB_HOST, TOC_HOST } from '../../config';
import { getHost } from '@tencent/ark-utils/lib/location';
export var DOC_HOST = "//".concat(getHost());
// online_docs 相关cgi地址
export var BASE_URL_ONLINE_DOCS = "".concat(DOC_HOST, "/cgi-bin/online_docs/");
// api 相关cgi地址
export var BASE_URL_API = "".concat(DOC_HOST, "/cgi-bin/api/");
// go 语言提供的cgi地址
export var BASE_URL_CGI_GO = "".concat(DOC_HOST, "/cgi-go/");
// V2 相关cgi地址 (user attribute)
export var BASE_URL_V2 = "".concat(DOC_HOST, "/v2/");
// V3 相关cgi地址
export var BASE_URL_V3 = "".concat(DOC_HOST, "/v3/");
// SDC 相关cgi地址 (getusermarkname)
export var BASE_URL_SDC = "".concat(DOC_HOST, "/cgi-go/");
export var WECOM_DOC_HOST = "//".concat(TOB_HOST);
export var DOCS_HOST = "//".concat(TOC_HOST);
